import { render, staticRenderFns } from "./Competencias.vue?vue&type=template&id=dfcc2e40&"
import script from "./Competencias.vue?vue&type=script&lang=js&"
export * from "./Competencias.vue?vue&type=script&lang=js&"
import style0 from "vue-slim-tabs/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./Competencias.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports